import { email } from './email/email';
import { filipinoName } from './filipino-name/filipino-name';
import { latinText } from './latin-text/latin-text';
import { maxLength } from './max-length/max-length';
import { mobilePhoneFormatPh } from './mobile-phone-format-ph/mobile-phone-format-ph';
import { phoneFormatPh } from './phone-format-ph/phone-format-ph';
import { phoneLength } from './phone-length/phone-length';
import { required } from './required/required';

export const validators = {
  phoneLength,
  phoneFormat: phoneFormatPh,
  mobilePhoneFormat: mobilePhoneFormatPh,
  required,
  maxLength,
  filipinoName,
  email,
  latinText,
};
